exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".otMCteCBpLYySh06dIWaP>div{padding-left:0;padding-right:0}\n", ""]);

// exports
exports.locals = {
	"contactmodal": "otMCteCBpLYySh06dIWaP"
};